module.exports = __webpack_public_path__ + "img/IC_plan_biometrico_secondary.e54194bd.svg";